import { useEffect, useState } from "react"
import { TopBar } from "../../_shared/TopBar"
import './webinars.scss'
import { getFirestore, collection, getDocs } from "firebase/firestore"
import { firebaseApp } from "../../system/firebase"
import { useNavigate } from "react-router-dom"

export const RouteWebinars = () => {
    const [events, setEvents] = useState([]);

    useEffect(() => {
        const db = getFirestore(firebaseApp);
        getDocs(collection(db, 'ALL_EVENTS')).then((snapshot) => {
            const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setEvents(list);
        });
    }, []);

    return <div className="screen-webinars">
        <TopBar />
        <div className="container">
            <div className="navbar-header">
                <button className="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                    <span className="icon icon-bar" />
                    <span className="icon icon-bar" />
                    <span className="icon icon-bar" />
                </button>
                <a href="index" className="navbar-brand">
                    <span className="image-text">ABSK</span> <sup>Africa</sup>
                </a>
            </div>
            <div className="collapse navbar-collapse">
                <ul className="nav navbar-nav navbar-nav-first">
                </ul>
                <ul className="nav navbar-nav navbar-right">
                    <li className="active"><a href="/index#home" className="smoothScroll">Home</a></li>
                    <li><a style={{ color: "goldenrod" }} href="/webinars" className="smoothScroll">Events</a></li>
                    <li><a href="/index#courses" className="smoothScroll">Courses</a></li>
                    <li><a href="/index#counselling" className="smoothScroll">Counselling</a></li>
                    <li><a href="/index#about" className="smoothScroll">About</a></li>
                    <li><a href="/index#contact" id="open-mailer" className="smoothScroll">Contacts</a></li>
                </ul>
            </div>
        </div>
        <h1 className="top-title">Upcoming Events</h1>
        <p className="top-info">Register for the ABSK webinar series here and we will email you a link before each webinar.</p>

        {events.map((eventt, index) => {
            if (eventt.eventType === 'Conference') {
                return <ConferenceCard key={index} event={eventt} />;
            }
            return <WebinarCard key={index} event={eventt} />;
        })}
    </div>
}

// Safely convert any date value (string | timestamp | Date) → "Mon DD YYYY"
const formatDate = (raw) => {
    if (!raw) return '';
    if (typeof raw === 'string') return raw;
    // numeric timestamp (ms or s)
    const ms = typeof raw === 'number' && raw < 1e12 ? raw * 1000 : raw;
    return new Date(ms).toDateString(); // e.g. "Thu Mar 06 2025"
};

const WebinarCard = ({ event }) => {
    const dateParts = formatDate(event.date).split(" ");
    return (
        <div className="webinar-banner">
            <div className="date-label">
                <div>{dateParts[0]} {dateParts[1]}</div>
                <div>{dateParts[2]}</div>
            </div>
            <div className="left">
                <h1>{event.title}</h1>
                <h4>by {event.speaker}</h4>
                <p>{event.speakerInfo || event.description}</p>
            </div>
            <div className="right"></div>
            <a href="/webinar-registration" className="register-bt">Register</a>
        </div>
    );
}

const ConferenceCard = ({ event }) => {
    const navigate = useNavigate();
    const handleRegister = (event) => {
        if (event.eventType === 'Webinar') {
            navigate('/webinar-registration');
        } else {
            navigate('/conference-registration/' + event.id);
        }
    };
    return (
        <div className="webinar-banner conference-banner">
            <div className="conference-type-badge">Conference</div>
            <div className="conference-header">
                <div className="date-grid">
                    <div className="date-label">
                        <div>{formatDate(event.startDate).split(" ")[0]}</div>
                        <div>{formatDate(event.startDate).split(" ")[1]}</div>
                        <div>{formatDate(event.startDate).split(" ")[2]}</div>
                    </div>
                    <div className="hyphen"> - </div>
                    <div className="date-label last">
                        <div>{formatDate(event.endDate).split(" ")[0]}</div>
                        <div>{formatDate(event.endDate).split(" ")[1]}</div>
                        <div>{formatDate(event.endDate).split(" ")[2]}</div>
                    </div>
                </div>
                <div className="conference-title-block">
                    <h1>{event.name}</h1>
                    {event.theme && <h4 className="conference-theme">Theme: {event.theme}</h4>}
                </div>
            </div>

            <div className="conference-details">
                {event.venue && (
                    <div className="conference-detail-row">
                        <span className="detail-label">Venue:</span>
                        <span className="detail-value">{event.venue}</span>
                    </div>
                )}
                {event.keynoteSpeaker && (
                    <div className="conference-detail-row">
                        <span className="detail-label">Keynote Speaker:</span>
                        <span className="detail-value">{event.keynoteSpeaker}</span>
                    </div>
                )}
                {event.topic && (
                    <div className="conference-detail-row">
                        <span className="detail-label">Topic:</span>
                        <span className="detail-value">{event.topic}</span>
                    </div>
                )}
                {(event.institution || event.department) && (
                    <div className="conference-detail-row">
                        <span className="detail-label">Institution:</span>
                        <span className="detail-value">
                            {event.institution}{event.institution && event.department ? ' — ' : ''}{event.department}
                        </span>
                    </div>
                )}
                {event.info && (
                    <div className="conference-detail-row">
                        <span className="detail-label">Info:</span>
                        <span className="detail-value">{event.info}</span>
                    </div>
                )}
                {event.deadline && (
                    <div className="conference-detail-row">
                        <span className="detail-label">Deadline:</span>
                        <span className="detail-value">{event.deadline}</span>
                    </div>
                )}
                {event.email && (
                    <div className="conference-detail-row">
                        <span className="detail-label">Contact:</span>
                        <span className="detail-value">
                            <a href={`mailto:${event.email}`}>{event.email}</a>
                        </span>
                    </div>
                )}
            </div>

            {(event.physicalFee || event.virtualFee) && (
                <div className="conference-fees">
                    <h4 className="fees-title">Registration Fees</h4>
                    <div className="fees-row">
                        <div className="fee-item">
                            <div className="fee-left">
                                <span className="fee-label">Physical</span>
                                <span className="fee-amount">KES {event.physicalFee}</span>
                            </div>
                            <div className="fee-right">
                                <span className="fee-label">Inclusive of </span>
                                <span className="fee-amount">{event.physicalFeeInclusives}</span>
                            </div>
                        </div>
                        <div className="fee-item">
                            <div className="fee-left">
                                <span className="fee-label">Virtual</span>
                                <span className="fee-amount">KES {event.virtualFee}</span>
                            </div>
                            <div className="fee-right">
                                <span className="fee-label">Inclusive of </span>
                                <span className="fee-amount">{event.virtualFeeInclusives}</span>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {(event.mpesaPaybill || event.bankName) && (
                <div className="conference-payment">
                    <h4 className="payment-title">Payment Details</h4>
                    <div className="payment-methods">
                        {event.mpesaPaybill && (
                            <div className="payment-method">
                                <span className="payment-method-name">M-PESA</span>
                                <div className="payment-method-detail">
                                    <span>Paybill: <strong>{event.mpesaPaybill}</strong></span>
                                    {event.mpesaAccount && <span>Account: <strong>{event.mpesaAccount}</strong></span>}
                                </div>
                            </div>
                        )}
                        {event.bankName && (
                            <div className="payment-method">
                                <span className="payment-method-name">Bank</span>
                                <div className="payment-method-detail">
                                    <span>Bank: <strong>{event.bankName}</strong></span>
                                    {event.bankAccount && <span>Account: <strong>{event.bankAccount}</strong></span>}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
            <div className="register-bt" onClick={() => handleRegister(event)}>
                Register Now
            </div>
        </div>
    );
}